/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { CLEAN_UP, MERGED_STREAM_UPDATED, STARTOVER_CLICKED, UNMOUNT_CLEAN_UP } from '../../constants/ActionTypes';
export default function soundMeterMiddleware({
  dispatch,
  getState
}) {
  return next => action => {
    const state = getState();
    switch (action.type) {
      case MERGED_STREAM_UPDATED:
        Promise.resolve().then(() => {
          const soundMeter = state.soundMeter,
            streamMerger = state.streamMerger;
          const stream = streamMerger.getStream();
          soundMeter.disconnectPrevStream();
          if (stream) {
            soundMeter.connectToSource(stream);
          }
        }).catch(error => {
          console.error('soundMeter error', error);
        });
        break;
      case CLEAN_UP:
      case STARTOVER_CLICKED:
        Promise.resolve().then(() => {
          const soundMeter = state.soundMeter;
          soundMeter.disconnectPrevStream();
        }).catch(error => {
          console.error('soundMeter error', error);
        });
        break;
      case UNMOUNT_CLEAN_UP:
        state.soundMeter.stop().catch(error => {
          console.error('soundMeter error', error);
        });
    }
    return next(action);
  };
}